import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { IrregularProduct } from 'scenes/Producer/Product/MyProducts/constants';
import productService from 'v2/services/product';

function useIrregularProductVariations(
  parentId: number,
  options?: Omit<UseQueryOptions<IrregularProduct[]>, 'queryKey' | 'queryFn'>
) {
  return useQuery<IrregularProduct[]>({
    queryKey: ['product', parentId, 'irregular-variations'],
    queryFn: () => productService.getIrregularProductVariations(parentId),
    ...options
  });
}

export { useIrregularProductVariations };
